import {CommonPlace, Place, PlaceNickname, ScratchCommonPlace} from "./PlaceTypes"
import {PlaceCategory} from "../../graphql/queries"
import {ID} from "../id"

export function placeAddress(place: Place) {
  const {optionalName, address} = place

  return optionalName ? optionalName + "; " + address : address
}

export function placeName(
  commonPlaces: Array<CommonPlace>,
  place: Place,
  isAdmin?: boolean,
): string {
  const commonPlace = maybeCommonPlace(commonPlaces, place.id)
  if (commonPlace) {
    const {shortLabel, label} = commonPlace
    return isAdmin && shortLabel ? shortLabel : label
  }

  return placeAddress(place)
}

export function placeCategory(
  commonPlaces: Array<CommonPlace>,
  place: Place,
): PlaceCategory | null {
  const commonPlace = maybeCommonPlace(commonPlaces, place.id)
  if (commonPlace) {
    return commonPlace.category
  }

  return null
}

export function maybeCommonPlace(commonPlaces: Array<CommonPlace>, placeId: ID) {
  return commonPlaces.find((commonPlace) => commonPlace.id === placeId)
}

export function maybePlaceNickname(nicknames: Array<PlaceNickname>, placeId: ID) {
  return nicknames.find((nickname) => nickname.id === placeId)
}

export const emptyCommonPlace: ScratchCommonPlace = {
  id: null,
  placeId: null,
  localeId: null,
  label: "",
  shortLabel: "",
  suggest: false,
  category: PlaceCategory.Place,
}

export function toScratchCommonPlace(cp: CommonPlace): ScratchCommonPlace {
  return {
    id: cp.id,
    placeId: cp.placeId,
    localeId: cp.locale.id,
    label: cp.label,
    shortLabel: cp.shortLabel,
    suggest: cp.suggest,
    category: cp.category,
  }
}



// WEBPACK FOOTER //
// ./src/model/places/place.ts